import { render, staticRenderFns } from "./ChangePasswordRules.vue?vue&type=template&id=6cc76e0d&scoped=true&"
import script from "./ChangePasswordRules.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordRules.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordRules.vue?vue&type=style&index=0&id=6cc76e0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc76e0d",
  null
  
)

export default component.exports